import MainPage from "../components/MainPage"

function Home() {
  return (
      <MainPage/>
  );
}

export default Home;
